import { create } from "zustand";

const useScrollStore = create((set) => ({
  superuserSchoolTableScroll: null,
  setSuperuserSchoolTableScroll: (scroll) =>
    set({ superuserSchoolTableScroll: scroll }),
}));

export default useScrollStore;
